


































































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import loader from "@/components/loader.vue";
import accountsApi from "@/services/accounts";
import billingAPI from "@/services/billing";
import { debounce, cancel } from "typescript-debounce-decorator";
import { Getter, Action, Mutation } from "vuex-class";
import { Account } from "../../models/account";
import { Currency } from "@/models/currency";
import { PackageGroup } from "../../models/packagegroup";
import clone from "@/helpers/clone";
import PackageHelpers, { Package } from "../../models/package";
import OrderHelpers, { Order } from "../../models/order";
import Currencies from "@/helpers/Currencies";
import ProductIcon from "@/components/ProductIcon.vue";
import { WarehousePackage } from "@/models/warehousePackage";
import { Warehouse } from "@/models/warehouse";
import { ServiceMatrix } from "@/models/serviceMatrix";
import { editCustom } from "@/dialogs/package"

@Component({
  components: {
    loader,
    ProductIcon,
    editCustom
  },
})
export default class SelectCustomer extends Vue {
  private get needShippingAddress() {
    return OrderHelpers.NeedShippingAddress(this.order);
  }
  private get valid() {
    return OrderHelpers.HasPackages(this.order);
  }

  get allCurrencies() {
    const cc = Currencies.map((c: any) => ({
      code: c.code,
      label: `${c.label} (${c.code})`,
    })).filter((c) => {
      // if (this.order && this.order.currency == "USD" && c.code == "ZAR")
      //   return false;
      return true;
    });
    return cc;
  }
  private get currency() {
    if (!this.order) {
      return "ZAR";
    }
    return this.order.currency || "ZAR";
  }
  @Mutation("setLastErr") public setLastErr: any;

  // order passed as prop, then emit('update',{field: value}, sync?) to update.
  @Prop({ required: true }) public order!: Order;

  private groupsFilterred: PackageGroup[] = [];
  private loading = true;

  private searchString = "";
  private allPackageGroups = [];

  // custom package
  private customPackage = {
    code: "CUSTOM1",
    category: "custom",
    description: "",
    title: "",
    discount_rate: 0,
    qty: 0,
    shippable: false,
  };

  // getters
  @Getter("displayPackageGroups") private displayPackageGroups: any;
  @Watch("searchString") public watchSearchString() {
    this.getGroupsFilterred();
  }
  @Watch("currency") public watchCurrency() {
    this.getGroupsFilterred();
  }

  @Getter("serviceMatrix") serviceMatrix!: ServiceMatrix[];
  get services() {
    return this.serviceMatrix.find(
      (mtix) => mtix.id === this.order!.service_matrix_id
    );
  }

  @Getter("warehouses") warehouses!: Warehouse[];
  get warehouse() {
    if (!this.order) return { id: 0 };
    return (
      this.warehouses.find((wh) => wh.id === this.services!.warehouse_id) || {
        id: 0,
      }
    );
  }
  @Getter("warehousepackages") warehousepackages!: WarehousePackage[];
  private isEnabled(warehouseID: number, ssCode: string) {
    return this.warehousepackages.find(
      (wp) => wp.warehouse_id == warehouseID && wp.short_code == ssCode
    )
      ? true
      : false;
  }

  private getGroupsFilterred() {
    if (!this.order) {
      return;
    }
    this.groupsFilterred = this.allPackageGroups
      .map((pg: PackageGroup) => {
        const ob: PackageGroup = {
          title: pg.title,
          group: pg.group,
          category: pg.category,
          description: pg.description,
          qty: 1,
          packages: pg.packages.filter(
            (p: Package) =>
              p.currency === this.currency &&
              p.is_public &&
              this.isEnabled(
                this.warehouse.id || 0,
                p.short_code || p.code.substr(0, 10)
              )
          ),
        };
        ob.selectedPackage = ob.packages[0];
        return ob;
      })
      .filter(
        (pg: PackageGroup) =>
          pg.packages.length > 0 &&
          (!this.searchString ||
            pg.title.toLowerCase().indexOf(this.searchString) !== -1 ||
            pg.description.toLowerCase().indexOf(this.searchString) !== -1)
      );
  }

  // set helpers
  private setSelectedCurrency(cur: string) {
    if (!this.order) return;
    this.$emit(
      "update",
      { currency_estimated: this.order.currency == cur ? "" : cur },
      true
    );
  }

  private async next() {
    if (this.needShippingAddress) {
      this.$router.push("shipping_address");
    } else {
      this.$router.push("billing_address");
    }
  }

  private async add(pg: any) {
    if (!pg.selectedPackage) {
      return;
    }

    let discount = pg.discount_rate || 0;
    if (discount > 100) {
      discount = 100;
    }
    if (discount < 0) {
      discount = 0;
    }
    // if (pg.selectedPackage.is_plan) discount = 0;

    this.$emit(
      "updatePackageQty",
      pg.selectedPackage.code,
      false,
      pg.qty,
      false,
      discount
    );
  }

  showEditCustom = false;
  private async addCustom(p: Package) {
    p = PackageHelpers.Format(p);
    if (!this.order || !this.order.packages) {
      return;
    }
    if (!p.price || !p.description) {
      return;
    }

    p.title = p.description;
    p.long_description = p.description;
    if (p.shippable && !PackageHelpers.HasSizeAndWeight(p)) {
      this.showEditCustom = true;
      return;
    }

    try {
      this.order.packages.push(p);
      this.$emit("update", { packages: this.order.packages }, true);
    } catch (e) {
      this.setLastErr(e);
      return;
    }

    // reset custom package
    let cnt = 2;
    let cCode = `CUSTOM${cnt}`;
    while (this.order.packages.find((pFind: Package) => pFind.code === cCode)) {
      cnt++;
      cCode = `CUSTOM${cnt}`;
    }

    this.customPackage = {
      code: cCode,
      category: "custom",
      description: "",
      title: "",
      discount_rate: 0,
      qty: 0,
      shippable: false,
    };
  }

  closeCustomPackageEdit(p: Package | false) {
    this.showEditCustom = false;
    if (p) {
      this.addCustom(p);
    }
  }

  private created() {
    // make copy and set
    this.allPackageGroups = clone(this.displayPackageGroups);
    this.getGroupsFilterred();
  }

  private mounted() {
    this.loading = false;
  }

  private discountLimit(v: any) {
    let n = Math.trunc(Number(v));
    if (n < 0) {
      n = 0;
    }
    if (n > 100) {
      n = 100;
    }
    return n;
  }
}
